import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { User, UserAccount, Users } from './types';

const BASE_URL = process.env.REACT_APP_ENDPOINT as string;

export const adminApi = createApi({
	reducerPath: 'adminApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${BASE_URL}`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem('userToken');
			if (token) {
				headers.set('authorization', `Bearer ${token}`);
			}
			return headers;
		},
	}),
	endpoints: (builder) => ({
		addAdminAccount: builder.mutation<null, UserAccount>({
			query(queryArg) {
				return {
					url: '/api/admin/create-user',
					method: 'POST',
					body: queryArg,
				};
			},
		}),

		getUsers: builder.query<Users, any>({
			query: ({ pageNumber, pageSize, sort, sortField, name, establishmentsIn }) => ({
				url: '/api/user/search',
				method: 'GET',
				params: { pageNumber, pageSize, sort, sortField, name, establishmentsIn },
				credentials: 'include',
			}),
		}),
		blockUser: builder.mutation<void, Partial<User>>({
			query(args) {
				return {
					url: '/api/public/lock-account',
					method: 'POST',
					body: args,
				};
			},
			async onQueryStarted(args, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
				} catch (error) {
					console.error('Error while upserting section:', error);
				}
			},
		}),
		unblockUser: builder.mutation<void, Partial<User>>({
			query(args) {
				return {
					url: '/api/public/unlock-account',
					method: 'POST',
					body: args,
				};
			},
			async onQueryStarted(args, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
				} catch (error) {
					console.error('Error while upserting section:', error);
				}
			},
		}),
	}),
});

export const { useAddAdminAccountMutation, useGetUsersQuery, useBlockUserMutation, useUnblockUserMutation } = adminApi;
